import { Injectable } from '@angular/core';
import { ROLES } from '../../constants/roles';
import { User } from '../../models/auth/user.model';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private authService: AuthService) {}

  isAdmin(): boolean {
    return !!this.user?.roles?.find(
      (role) => role.type === ROLES.ADMIN || role.name === ROLES.ADMIN,
    );
  }

  private get user(): User {
    return this.authService.getCurrentUser();
  }
}
